<div class="ai-thinking d-flex align-items-center">
    <div class="ai-thinking-mark flex-none mr-1">
        <div class="circle-progress circle-progress-lg circle-progress-halfmoon"></div>
        <img ycnImage [imageSrc]="'images/core/ycharts-logo-ai-circle.svg'" class="width-24 height-24" alt="">
    </div>
    <div class="text-large">{{ loadingLabel() }}<span class="ellipsis d-inline-block width-13"></span> ({{ elapsedSeconds() }}s)</div>
</div>
